import * as React from "react";
import "./styles/Onama.css";

export const Onama: React.FC = () => {
  return (
    <>
      <section className="page-header-kontakt"></section>

      <section className="section-content-block who-are-we">
        <div className="container">
          <div className="section-heading-wrapper">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="section-icon">
                  <i className="fas fa-users"></i>
                </div>
                <h2 className="section-heading-inline">Ko smo mi?</h2>
                <p className="section-subtitle">
                  Upoznajte tim stručnjaka koji stoji iza vaših najuspešnijih
                  projekata.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="about-us">
              <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="about-us-text">
                  <p>
                    Creativehub je agencija specijalizovana za PR i video
                    produkciju.
                  </p>
                  <p>
                    Naša misija je da kroz kreativni pristup kreiramo vrhunske
                    komunikacione strategije i produkcijske sadržaje koji
                    ostavljaju snažan i trajan utisak.
                  </p>
                  <p>
                    Iza nas su brojni uspješni projekti, među kojima se izdvaja
                    emisija „Đedovina”, u kojoj istražujemo i obilazimo
                    različite krajeve Crne Gore, razgovarajući s ljudima koji su
                    odlučili da ostanu u svojim rodnim mjestima i očuvaju
                    tradiciju – bilo kroz pokretanje sopstvenog biznisa ili
                    njegovanjem naslijeđenih vrijednosti.
                  </p>
                  <p>
                    Pored toga, bavimo se produkcijom dokumentarnih filmova,
                    organizacijom konferencija i raznovrsnih događaja.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-sm-12">
                <figure className="about-us-img">
                  <img
                    src="images/novilogo.jpg"
                    alt="CreativeHub"
                    loading="lazy"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-process-section">
        <div className="container">
          <div className="section-heading-wrapper">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="section-icon">
                  <i className="fas fa-cogs"></i>
                </div>
                <h2 className="section-heading-inline">Naš proces rada</h2>
                <p className="section-subtitle">
                  Upoznajte kako nastaju naše jedinstvene produkcije.
                </p>
              </div>
            </div>
          </div>

          <div className="portfolio-process">
            <div className="process-item">
              <div className="process-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <div className="process-content">
                <h4>Koncept</h4>
                <p>Razvoj kreativne ideje i koncepta za jedinstvenu priču</p>
              </div>
            </div>
            <div className="process-item">
              <div className="process-icon">
                <i className="fas fa-video"></i>
              </div>
              <div className="process-content">
                <h4>Snimanje</h4>
                <p>Profesionalno snimanje sa najsavremenijom opremom</p>
              </div>
            </div>
            <div className="process-item">
              <div className="process-icon">
                <i className="fas fa-edit"></i>
              </div>
              <div className="process-content">
                <h4>Postprodukcija</h4>
                <p>Kvalitetno montiranje i obrada za vrhunski rezultat</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-content-block event-section-1 section-secondary-bg">
        <div className="container wow fadeInUp">
          <div className="row section-heading-wrapper">
            <div className="col-md-12 col-sm-12 text-center">
              <h2 className="section-heading">
                <span>NAŠI</span> PARTNERI
              </h2>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img src="images/rtcg.png" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img
                    className="partner-logo-euronews"
                    src="images/euronews.jpg"
                    alt="Euronews Montenegro"
                  />
                </figure>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <a
                    href="http://www.altermodus.me"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="images/alter-modus.png" alt="" />
                  </a>
                </figure>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img src="images/investicioni-fond-logo.jpg" alt="" />
                </figure>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img src="images/montevideo-logo.png" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img src="images/prijestonica-cetinje-logo.png" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img src="images/cbcg-logo.jpg" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="event_wrapper-1 xs-margin">
                <figure className="event-img">
                  <img src="images/tobar-logo.jpg" alt="" />
                </figure>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <div
                className="event_wrapper-1 xs-margin"
                style={{ border: "none", background: "white" }}
              >
                <figure className="event-img">
                  <img src="images/TO MK lat.webp" alt="event" />
                </figure>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <div
                className="event_wrapper-1 xs-margin"
                style={{ border: "0px solid #dfdfdf" }}
              >
                <figure className="event-img">
                  <img src="images/herceg-novi.png" alt="event" />
                </figure>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <div
                className="event_wrapper-1 xs-margin"
                style={{ border: "0px solid #dfdfdf" }}
              >
                <figure className="event-img">
                  <img src="images/rozaje-logo.jpg" alt="event" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Primer overlay loading spinner-a */}
      {/*
      <LoadingSpinner
        size="large"
        text="Učitavanje sadržaja..."
        overlay={true}
      />
      */}
    </>
  );
};
